import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import {
	AuthTemplate,
	LoginFooter,
	LoginHeroImage,
	ResetPasswordForm,
	TermsAndConditions,
} from '../components';
import { useIsSpecificViewportWidth } from '../hooks/useIsSpecificViewportWidth';
import { TStyle } from '../types/TStyle';
import { getResponsiveStyle } from '../utils/getResponsiveStyle';
import { useAppDispatch } from '../redux/store';
import { setCurrentScreen } from '../redux/uiSlice';

const ResetPassword = () => {
	const { isDesktop } = useIsSpecificViewportWidth();
	const { t } = useTranslation();
	const dispatch = useAppDispatch();
	useEffect(() => {
		dispatch(setCurrentScreen('/reset-password'));
	}, []);
	return (
		<View style={isDesktop && styles.container}>
			<LoginHeroImage />
			<AuthTemplate
				heading={t('Reset Password')}
				subText={t('Enter new password for your account.')}
				contentStyles={styleMainContent()}
				authType={'login'}
				scrollItems={[]}
				hasGoBack={false}
			>
				<ResetPasswordForm />
				{isDesktop && <LoginFooter />}
				{isDesktop && <TermsAndConditions />}
			</AuthTemplate>
		</View>
	);
};

function styleMainContent(): TStyle {
	return {
		marginTop: getResponsiveStyle(40),
	};
}

const styles = StyleSheet.create({
	container: {
		flexDirection: 'row',
		minWidth: '100vw',
		height: '100vh',
	},
});

export default ResetPassword;
